// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"532":"styles","6680":"rtf_editor"}[chunkId] + ".css";
};